exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._37RIgfLaCbduTSfWjbfpuR {\n\n}\n", ""]);

// exports
exports.locals = {
	"enrollmentDates": "_37RIgfLaCbduTSfWjbfpuR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/EnrollmentDates/EnrollmentDates.css
// module id = 9492
// module chunks = 23